export default {
  namespaced: true,
  state: {
    users: [],
    abilities: [],
    roles: []
  },
  mutations: {
    addConversation(state, conversation) {
      let conversations = state.conversations;
      let item = conversations.find(item => item.id == conversation.id);
      if (!item) {
        conversations.push(conversation);
      } else {
        conversations[conversations.indexOf(item)] = conversation;
      }
      state.conversations = conversations;
    },
    setCurrentConversation(state, conversationId) {
      let conversation = state.conversations.find(
        item => item.id == conversationId
      );
      state.currentConversation = conversation;
    }
  },
  actions: {
    // @todo Здесь нужна мутация
    fetch({ state }) {
      axios.get('/api/ability/all').then(response => {
        state.abilities = response.data;
      });
      axios
        .get('/api/role/', {
          all: true
        })
        .then(response => {
          state.roles = response.data;
        });
    }
  }
};
